export default function (sellerName) {
  if (
    this.service === 'store' &&
    this.paper === 'privacy-3rd-party-non-member'
  ) {
    this.$nextTick(() => {
      const xpath = "//td[text()='{% seller %}']"
      const matchingElement = document.evaluate(
        xpath,
        document,
        null,
        XPathResult.FIRST_ORDERED_NODE_TYPE,
        null
      ).singleNodeValue
      matchingElement.innerText = sellerName
    })
  }
  else if (
    this.service === 'commerce' &&
    this.paper === 'customer-privacy-party'
  ) {
    this.$nextTick(() => {
      const xpath = "//td[text()='{% seller %}']"
      const matchingElement = document.evaluate(
        xpath,
        document,
        null,
        XPathResult.FIRST_ORDERED_NODE_TYPE,
        null
      ).singleNodeValue
      matchingElement.innerText = sellerName
    })
  }
}
